import React, { useState } from "react";
import { Card, Button, ProgressBar, Dropdown, Modal, Form } from "react-bootstrap";

const DashboardPrimaria = () => {
  const [cursos, setCursos] = useState([
    {
      id: 1,
      nombre: "Matemáticas - 4to Grado",
      descripcion:
        "Este curso enseña matemáticas básicas para estudiantes, cubriendo operaciones fundamentales y problemas.",
      progreso: 100,
      estado: "Finalizado",
      banner:
        "https://www.shutterstock.com/image-vector/mathematics-typographic-header-learning-geometry-600nw-1954222000.jpg",
    },
    {
      id: 2,
      nombre: "Ciencias Naturales - 5to Grado",
      descripcion:
        "Curso interactivo de ciencias naturales, explorando los ecosistemas y la vida animal.",
      progreso: 75,
      estado: "En progreso",
      banner:
        "https://i.pinimg.com/originals/34/64/ab/3464ab1f34476cfa898b2233c2bfb40a.jpg",
    },
  ]);

  const [showModal, setShowModal] = useState(false);
  const [editingCurso, setEditingCurso] = useState(null);
  const [formData, setFormData] = useState({
    nombre: "",
    descripcion: "",
    progreso: 0,
    estado: "En progreso",
    banner: "",
  });

  // Abrir y cerrar el modal
  const handleShowModal = () => {
    setEditingCurso(null);
    setFormData({
      nombre: "",
      descripcion: "",
      progreso: 0,
      estado: "En progreso",
      banner: "",
    });
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  // Manejar cambios en el formulario
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Guardar curso (nuevo o editado)
  const handleSaveCurso = () => {
    if (editingCurso) {
      setCursos((prev) =>
        prev.map((curso) => (curso.id === editingCurso.id ? { ...formData, id: editingCurso.id } : curso))
      );
    } else {
      setCursos((prev) => [...prev, { ...formData, id: Date.now() }]);
    }
    handleCloseModal();
  };

  // Editar un curso
  const handleEditCurso = (curso) => {
    setEditingCurso(curso);
    setFormData(curso);
    setShowModal(true);
  };

  // Eliminar un curso
  const handleDeleteCurso = (id) => {
    setCursos((prev) => prev.filter((curso) => curso.id !== id));
  };

  return (
    <div className="container-fluid p-0">
      <Button variant="primary" className="float-end mt-n1" onClick={handleShowModal}>
        <i className="fas fa-plus"></i> Nuevo Curso
      </Button>
      <h1 className="h3 mb-3">Asignaturas</h1>

      <div className="row">
        {cursos.map((curso) => (
          <div className="col-12 col-md-6 col-lg-4" key={curso.id}>
            <Card className="mb-4 shadow-sm">
              <Card.Img
                variant="top"
                src={curso.banner}
                alt={`Imagen del curso ${curso.nombre}`}
                style={{ height: "200px", objectFit: "cover" }}
              />
              <Card.Header className="d-flex justify-content-between align-items-center">
                <div>
                  <Card.Title className="mb-0">{curso.nombre}</Card.Title>
                  <div
                    className={`badge bg-${
                      curso.estado === "Finalizado" ? "success" : "warning"
                    } my-2`}
                  >
                    {curso.estado}
                  </div>
                </div>
                <Dropdown>
                  <Dropdown.Toggle variant="light" id="dropdown-basic">
                    <i className="fas fa-ellipsis-h"></i>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleEditCurso(curso)}>Editar</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleDeleteCurso(curso.id)}>Eliminar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Card.Header>
              <Card.Body>
                <Card.Text className="text-muted">{curso.descripcion}</Card.Text>
              </Card.Body>
              <Card.Footer>
                <p className="mb-2 fw-bold">
                  Progreso <span className="float-end">{curso.progreso}%</span>
                </p>
                <ProgressBar
                  now={curso.progreso}
                  variant={curso.progreso === 100 ? "success" : "warning"}
                />
              </Card.Footer>
            </Card>
          </div>
        ))}
      </div>

      {/* Modal para agregar/editar curso */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{editingCurso ? "Editar Curso" : "Nuevo Curso"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Nombre del Curso</Form.Label>
              <Form.Control
                type="text"
                name="nombre"
                value={formData.nombre}
                onChange={handleInputChange}
                placeholder="Ingrese el nombre del curso"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Descripción</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="descripcion"
                value={formData.descripcion}
                onChange={handleInputChange}
                placeholder="Ingrese una descripción breve"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Progreso (%)</Form.Label>
              <Form.Control
                type="number"
                name="progreso"
                value={formData.progreso}
                onChange={handleInputChange}
                placeholder="0-100"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Estado</Form.Label>
              <Form.Select
                name="estado"
                value={formData.estado}
                onChange={handleInputChange}
              >
                <option>En progreso</option>
                <option>Finalizado</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Banner URL</Form.Label>
              <Form.Control
                type="text"
                name="banner"
                value={formData.banner}
                onChange={handleInputChange}
                placeholder="URL de la imagen del curso"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSaveCurso}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DashboardPrimaria;
